<template>
  <v-container class="mt-16" id="about-us" fluid tag="section">
    <v-row justify="center">
      <v-col cols="12" md="8">
        <v-card>
          <v-card-title >
            <h1 v-text="$t('aboutUsTitle')"></h1>
          </v-card-title>
          <v-card-text>
            <v-row>
              <v-col cols="12" md="6" >
                 <pre style="font-family:BKoodakBold !important; white-space: break-spaces;" v-text="$t('aboutUs')"> </pre>
              </v-col>
              <v-col cols="12" md="6" >
                <v-sheet>
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d963.0251359790165!2d51.33470217643864!3d35.72086812725383!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3f8dfdedb63d8ca5%3A0x7eacd9e7b7741922!2z2YXYsdmD2LIg2K7YsdmK2K8g2LPYp9mF2KfZhg!5e0!3m2!1sfa!2sae!4v1595008413355!5m2!1sfa!2sae"
                 width="100%"
                height="450"
                frameborder="0"
                style="border:0"
                allowfullscreen
              ></iframe>
            </v-sheet>
              </v-col>
            </v-row>
             
              <!-- <v-img v-if="$i18n.locale == 'fa'" src="@/assets/MAHSOLAT_FTA.jpg"/> -->
          </v-card-text>
         
        </v-card>
      </v-col>

      <!-- <v-col cols="12" md="4">
        <v-card class="v-card-profile" >
             <v-card-title v-text="$t('aboutUsAddressTitle')">
            
          </v-card-title>
          <v-card-text class="text-center">
            <div  v-text="$t('ourAddress')">
              
            </div>
            <v-sheet>
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d963.0251359790165!2d51.33470217643864!3d35.72086812725383!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3f8dfdedb63d8ca5%3A0x7eacd9e7b7741922!2z2YXYsdmD2LIg2K7YsdmK2K8g2LPYp9mF2KfZhg!5e0!3m2!1sfa!2sae!4v1595008413355!5m2!1sfa!2sae"
                 width="100%"
                height="450"
                frameborder="0"
                style="border:0"
                allowfullscreen
              ></iframe>
            </v-sheet>
          
          </v-card-text>
        </v-card>
      </v-col> -->
    </v-row>
  </v-container>
</template>

<script>
export default {};
</script>
